<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>个人信息</span>
          </div>
          <div>
            <ul class="list-group list-group-striped">
              <li class="list-group-item">
                <el-icon class="el-icon-user" />用户名称
                <div class="pull-right">{{ user.userName }}</div>
              </li>
              <li class="list-group-item">
                <el-icon class="el-icon-phone" /> 手机号码
                <div class="pull-right">{{ user.phone }}</div>
              </li>
              <li class="list-group-item">
                <el-icon class="el-icon-s-custom" />所属角色
                <div class="pull-right">{{ user.role }}</div>
              </li>
              <li class="list-group-item">
                <el-icon class="el-icon-s-date" />创建日期
                <div class="pull-right">{{ createDate }}</div>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本资料</span>
          </div>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本资料" name="userinfo">
              <userInfo :user="user" />
            </el-tab-pane>
            <el-tab-pane label="修改密码" name="resetPwd">
              <resetPwd />
            </el-tab-pane>
            <!-- <el-tab-pane label="忘记密码" name="initPwd">
              <initPwd />
            </el-tab-pane> -->
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { sysUserInfo} from '@/api/userMG'
import userInfo from "./components/userInfo";
import resetPwd from "./components/resetPassword.vue";
// import initPwd from "./components/initPwd.vue";
export default {
  data() {
    return {
        user:{
            userName:'',
            nickName:'',
            phone:'',
            sex:'',
            role:'',
        },
        createDate:'',
        activeTab:'userinfo'
      }
  },
  components:{userInfo,resetPwd,},
  created() {
    this.getUserInfo()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getUserInfo(){
        sysUserInfo().then(res => {
          this.user = res.body
          this.createDate = res.body.createDate
        })
    },
   
  }
}
</script>

<style scoped>
.box-card ul{
    padding-left: 0;
}
.box-card ul li{
    list-style: none;
    border-bottom: 1px solid #e7eaec;
    /* border-top: 1px solid #e7eaec; */
    margin-bottom: -1px;
    padding: 11px 0;
    font-size: 13px;
}
.box-card{
    margin-top: 20px;
}
.pull-right{
    float: right;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/userCenter.vue